(() => {
  const attributionKeys = ['btk_cid','btk_vid','utm_source','utm_medium','utm_campaign','utm_content','utm_id','utm_term','gclid','gbraid','wbraid','yclid','fbclid','ttclid','cid','p','im'];
  const attribution = {};
  const params = new URLSearchParams(location.search);
  let saved = {};
  try {
    const entry = JSON.parse(localStorage.getItem('btk_params') || '{}');
    if (entry.savedAt && Date.now() - entry.savedAt >= 0 && Date.now() - entry.savedAt < 30 * 86400000) saved = entry.params || {};
  } catch {}
  attributionKeys.forEach(key => {
    const value = params.get(key) || saved[key];
    if (typeof value === 'string' && value.trim() && value.length <= 512) attribution[key] = value.trim();
  });
  if (Object.keys(attribution).length) {
    try { localStorage.setItem('btk_params', JSON.stringify({savedAt: Date.now(),params: attribution})); } catch {}
  }
  if (attribution.p && attribution.cid) {
    try { localStorage.setItem('CL_' + attribution.p, attribution.cid); } catch {}
    document.cookie = 'CL_' + encodeURIComponent(attribution.p) + '=' + encodeURIComponent(attribution.cid) + '; max-age=2592000; path=/; SameSite=Lax; Secure';
  }
  const dialog = document.getElementById('BunkerExpressDialog');
  const form = document.getElementById('BunkerExpressProduct');
  if (!dialog) return;
  const closeButton = dialog.querySelector('.spx-wallet-close');
  const status = dialog.querySelector('.spx-wallet-status');
  const fallback = dialog.querySelector('[data-spx-standard]');
  const preparedHost = document.getElementById('BunkerExpressPrepared');
  const price = dialog.querySelector('.spx-wallet-product strong');
  const productPrice = price?.textContent;
  const root = (dialog.dataset.cartRoot || '/').replace(/\/?$/, '/');
  const section = dialog.dataset.prepareSection;
  let opener, slowLoadingTimer, walletTiming, preparing;
  let redirecting = false, walletInteracted = false, verifiedAt = 0;
  let mode = form && preparedHost ? 'preparing' : 'product';
  let panelStarted = 0, panelEpoch = 0;
  let prepareResult = 'pending';
  const clock = () => window.performance?.now() || 0;
  const track = (name, data) => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof window.gtag === 'function' && privacy?.analyticsProcessingAllowed?.()) {
      window.gtag('event',name,{send_to:'G-KZPMLPRWBF',...data,non_interaction:true});
    }
  };
  const timedSteps = new Set(['cartCreate','cartQuery','cartAttributesUpdate','applePaySessionCreate','cartUpdateDeliveryAddressAndContact','cartSelectedDeliveryOptionsUpdate']);
  if (window.PerformanceObserver) {
    try {
      new window.PerformanceObserver(list => {
        if (!walletTiming) return;
        for (const entry of list.getEntries()) {
          if (entry.startTime < walletTiming.started || entry.startTime - walletTiming.started > 120000 || walletTiming.count >= 16) continue;
          const url = new URL(entry.name,location.origin);
          const step = url.searchParams.get('operation_name');
          if (url.origin !== location.origin || !/^\/api\/[^/]+\/graphql\.json$/.test(url.pathname) || !timedSteps.has(step)) continue;
          walletTiming.count += 1;
          const timing = {wallet_type:walletTiming.wallet,wallet_flow:walletTiming.flow,wallet_step:step,duration_ms:Math.round(entry.duration),elapsed_ms:Math.round(entry.startTime + entry.duration - walletTiming.started),panel_elapsed_ms:Math.round(entry.startTime + entry.duration - panelStarted)};
          console.debug('[BUNKER wallet timing]',timing);
          track('bunker_wallet_step',timing);
        }
      }).observe({type:'resource',buffered:false});
    } catch {}
  }
  const productCheckoutUrl = () => {
    const target = new URL(root + 'cart/' + dialog.dataset.variant + ':1',location.origin);
    Object.entries(attribution).forEach(([key,value]) => {
      target.searchParams.set(key,value);
      target.searchParams.set('attributes[' + key + ']',value);
    });
    target.searchParams.set('ref','signalpack');
    target.searchParams.set('locale','ja');
    target.searchParams.set('attributes[lp_variant]','signalpack-shopify-express');
    target.searchParams.set('attributes[checkout_source]','guest');
    return target.href;
  };
  const checkoutUrl = () => mode === 'cart' ? new URL(root + 'checkout',location.origin).href : productCheckoutUrl();
  if (form) Object.entries(attribution).forEach(([key,value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[_' + key + ']';
    input.value = value;
    form.appendChild(input);
  });
  const activeForm = () => mode === 'cart' ? preparedHost.querySelector('form') : form;
  const walletState = () => {
    if (mode === 'preparing') return 'preparing';
    const current = activeForm();
    if (!current) return 'unavailable';
    const host = current.querySelector('shopify-accelerated-checkout,shopify-accelerated-checkout-cart');
    const names = host ? [...host.children].map(child => child.tagName.toLowerCase()) : [];
    if (names.some(name => /apple-pay|google-pay/.test(name))) return 'wallet';
    if (mode === 'cart' && !host) return 'standard';
    if (current.querySelector('shopify-buy-it-now-button,.shopify-payment-button__button--unbranded')) return 'standard';
    if (names.some(name => /shop-pay|paypal|amazon-pay|venmo/.test(name))) return 'standard';
    if (mode === 'cart' && form?.querySelector('shopify-buy-it-now-button,.shopify-payment-button__button--unbranded')) return 'standard';
    return 'loading';
  };
  const updateWallet = () => {
    if (form) form.hidden = mode !== 'product';
    if (preparedHost) preparedHost.hidden = mode !== 'cart';
    if (fallback) fallback.href = checkoutUrl();
    const state = walletState();
    dialog.dataset.walletFlow = mode;
    dialog.dataset.walletState = state;
    if (!dialog.open || redirecting || walletInteracted) return;
    if (state === 'wallet' || state === 'unavailable') {
      clearTimeout(slowLoadingTimer);
      if (status) status.hidden = true;
    } else if (state === 'standard') {
      clearTimeout(slowLoadingTimer);
      redirecting = true;
      if (status) {status.hidden=false;status.textContent='購入手続きへ進みます。';}
      location.assign(checkoutUrl());
    } else if (status) {
      status.hidden=false;
      status.textContent=state==='preparing'?'購入内容を準備しています。':'利用できるお支払い方法を確認しています。';
    }
  };
  const compatible = cart => cart.item_count === 1 && cart.items?.length === 1 && String(cart.items[0].variant_id) === dialog.dataset.variant && !cart.items[0].selling_plan_allocation;
  const request = async (path, body) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(),12000);
    try {
      const response = await fetch(root + path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:path.includes('?sections=')?'*/*':'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
      if (!response.ok) throw Error('Cart request failed');
      return await response.json();
    } finally {clearTimeout(timer);}
  };
  const renderPrepared = async html => {
    if (!html) {
      const result = await request('cart?sections=' + encodeURIComponent(section));
      html = result[section];
    }
    if (!html || walletInteracted) {prepareResult='missing_section';return false;}
    const parsed = new DOMParser().parseFromString(html,'text/html');
    const content = parsed.querySelector('[data-spx-prepared="true"]');
    if (!content?.querySelector('shopify-accelerated-checkout-cart')) {prepareResult='invalid_section';return false;}
    preparedHost.replaceChildren(document.importNode(content,true));
    if (price) price.textContent = content.dataset.cartMoney || productPrice;
    mode = 'cart';
    prepareResult='ready';
    verifiedAt = Date.now();
    return true;
  };
  const useProduct = () => {
    if (walletInteracted) return;
    mode = 'product';
    if (price) price.textContent = productPrice;
  };
  const prepare = (allowAdd = false) => {
    if (preparing) return preparing;
    if (!form || !preparedHost || !section || !navigator.locks?.request) {
      prepareResult='unsupported';dialog.dataset.prepareResult=prepareResult;useProduct();updateWallet();return Promise.resolve();
    }
    const started = clock();
    preparing = navigator.locks.request('bunker-signalpack-prepared-cart',async () => {
      if (walletInteracted) return;
      let cart = await request('cart.js');
      let html;
      const properties = {_lp_source:'signalpack-shopify-express',...Object.fromEntries(Object.entries(attribution).map(([k,v])=>['_' + k,v]))};
      if (cart.item_count === 0 && allowAdd) {
        const result = await request('cart/add.js',{items:[{id:Number(dialog.dataset.variant),quantity:1,properties}],sections:[section],sections_url:root+'cart'});
        html = result.sections?.[section];
        if (!html) cart = await request('cart.js');
      } else if (!compatible(cart)) {
        prepareResult='existing_cart';useProduct();return;
      } else if (Object.entries(properties).some(([key,value]) => cart.items[0].properties?.[key] !== value)) {
        cart = await request('cart/change.js',{id:cart.items[0].key,quantity:1,properties:{...cart.items[0].properties,...properties},sections:[section],sections_url:root+'cart'});
        html = cart.sections?.[section];
      }
      if (!html && !compatible(cart)) {useProduct();return;}
      if (!await renderPrepared(html)) useProduct();
    }).catch(error => {prepareResult='request_error';console.warn('[BUNKER cart preparation]',error.name,error.message);useProduct();}).finally(() => {
      preparing = null;
      dialog.dataset.prepareResult=prepareResult;
      track('bunker_wallet_prepare',{wallet_flow:mode,prepare_result:prepareResult,prepare_ms:Math.round(clock()-started),prepare_trigger:allowAdd?'page_load':'cart_check'});
      updateWallet();
    });
    return preparing;
  };
  if (form) new MutationObserver(updateWallet).observe(form,{childList:true,subtree:true});
  if (preparedHost) new MutationObserver(updateWallet).observe(preparedHost,{childList:true,subtree:true});
  dialog.addEventListener('click',event => {
    const walletButton = event.composedPath().find(node => /^(SHOPIFY-APPLE-PAY-BUTTON|SHOPIFY-GOOGLE-PAY-BUTTON)$/.test(node.tagName || ''));
    if (!walletButton) return;
    walletInteracted = true;
    walletTiming = {started:clock(),wallet:walletButton.tagName.includes('APPLE')?'apple_pay':'google_pay',flow:mode,count:0};
    clearTimeout(slowLoadingTimer);
  },true);
  if (fallback) fallback.addEventListener('click',async event => {
    event.preventDefault();
    if (redirecting) return;
    redirecting=true;
    const epoch=panelEpoch;
    if (preparing) await preparing;
    if (!dialog.open || epoch!==panelEpoch) return;
    location.assign(checkoutUrl());
  });
  const close = () => {
    clearTimeout(slowLoadingTimer);
    panelEpoch+=1;
    walletTiming=null;
    dialog.close();
    if (opener?.isConnected) opener.focus({preventScroll:true});
  };
  const open = () => {
    if (dialog.open) return;
    panelEpoch+=1;
    redirecting=false;walletInteracted=false;
    panelStarted=clock();
    opener=document.activeElement;
    dialog.show();closeButton.focus({preventScroll:true});
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event:'bunker_express_open',lp_variant:'signalpack-shopify-express',item_id:dialog.dataset.variant});
    if (mode==='cart' && Date.now()-verifiedAt>10000) {mode='preparing';prepare(false);}
    updateWallet();
    if (['preparing','loading'].includes(walletState())) slowLoadingTimer=setTimeout(() => {
      if (dialog.open && ['preparing','loading'].includes(walletState()) && status && !walletInteracted) {
        status.textContent='購入内容を確認中です。ほかのお支払い方法も選べます。';
      }
    },5000);
  };
  closeButton.addEventListener('click',close);
  dialog.addEventListener('keydown',event => {if(event.key==='Escape'){event.preventDefault();close();}});
  dialog.addEventListener('cancel',event => {event.preventDefault();close();});
  document.addEventListener('visibilitychange',() => {
    if (document.visibilityState==='visible' && mode==='cart' && !walletInteracted) {mode='preparing';updateWallet();prepare(false);}
  });
  window.addEventListener('pageshow',event => {
    if (event.persisted && mode==='cart' && !walletInteracted) {mode='preparing';updateWallet();prepare(false);}
  });
  window.BunkerExpress={open};
  updateWallet();
  prepare(true);
})();
